import { render } from "./GalleryComponent.vue?vue&type=template&id=4786dc94&scoped=true"
import script from "./GalleryComponent.vue?vue&type=script&lang=js"
export * from "./GalleryComponent.vue?vue&type=script&lang=js"

import "./GalleryComponent.vue?vue&type=style&index=0&id=4786dc94&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4786dc94"]])

export default __exports__